// Chemin: C:\gestion-copro\src\components\ui\HelpBanner.tsx
// Composant réutilisable pour afficher une aide contextuelle fermable

import { useState, useEffect } from 'react';

interface HelpBannerProps {
  storageKey: string;       // Clé localStorage pour mémoriser la fermeture
  message: string;          // Message d'aide à afficher
  className?: string;       // Classes CSS additionnelles
}

export default function HelpBanner({ storageKey, message, className = '' }: HelpBannerProps) {
  const [isVisible, setIsVisible] = useState(false);

  // Vérifier si l'utilisateur a déjà fermé cette aide
  useEffect(() => {
    const dismissed = localStorage.getItem(storageKey);
    if (!dismissed) {
      setIsVisible(true);
    }
  }, [storageKey]);

  // Fermer l'aide et mémoriser le choix
  const handleDismiss = () => {
    localStorage.setItem(storageKey, 'true');
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className={`bg-blue-50 border border-blue-200 rounded-lg p-4 ${className}`}>
      <div className="flex items-start gap-3">
        {/* Icône info */}
        <div className="flex-shrink-0">
          <svg 
            className="w-5 h-5 text-blue-600 mt-0.5" 
            fill="currentColor" 
            viewBox="0 0 20 20"
          >
            <path 
              fillRule="evenodd" 
              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" 
              clipRule="evenodd" 
            />
          </svg>
        </div>
        
        {/* Message */}
        <div className="flex-1">
          <p className="text-sm text-blue-800">{message}</p>
        </div>
        
        {/* Bouton fermer */}
        <button
          onClick={handleDismiss}
          className="flex-shrink-0 text-blue-400 hover:text-blue-600 transition-colors"
          title="Fermer cette aide"
        >
          <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path 
              fillRule="evenodd" 
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" 
              clipRule="evenodd" 
            />
          </svg>
        </button>
      </div>
    </div>
  );
}